// extracted by mini-css-extract-plugin
export default {"root":"CustomSection_root__zweXQ","header":"CustomSection_header__U2Zk2","horizontal":"CustomSection_horizontal__2HD9c"};